import {
    makePersistData,
    makeRetrieveData,
    getStorageEngine,
} from 'common/util/persistent-storage';

const INDEXING_RESTORE_KEY = 'indexingrestore';
const indexStorageEngine = getStorageEngine('sessionStorage');
const saveIndexingData = makePersistData(indexStorageEngine, INDEXING_RESTORE_KEY);
const getIndexingData = makeRetrieveData(indexStorageEngine, INDEXING_RESTORE_KEY);

export function saveIndexingRestoreInfo({
    documentTypeId,
    descriptors,
    descriptorValues
}) {
    const data = {
        documentTypeId,
        descriptors,
        descriptorValues
    };
    saveIndexingData(INDEXING_RESTORE_KEY, data);
}

export function loadIndexingRestoreInfo() {
    return getIndexingData(INDEXING_RESTORE_KEY) || {};
}
